// Available locales only needed for multilanguage apps
export const availableLocales = [{value: "es-ES", label: "Español"}];

export const defaultLocale = "es-ES";
